import { render, staticRenderFns } from "./GUKTStatistics.vue?vue&type=template&id=e7b9cd8c&"
import script from "./GUKTStatistics.vue?vue&type=script&lang=js&"
export * from "./GUKTStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports